import {Injectable} from '@angular/core';

import { JsonHttpService } from '../../shared/http/json-http.service'
import { ErrorRule } from '../models/error-rule';
import { RulePosition } from '../models/error-rule-position';
import { HttpParams } from '@angular/common/http';

@Injectable({
    providedIn: 'root'
})
export class ErrorRulesService {

    constructor(private httpService: JsonHttpService) { }

    getErrorRules(): Promise<ErrorRule[]> {
        return this.httpService.get('/api/errorhandling/errorrules/get-errorrules').toPromise();
    }

    getErrorRule(errorRuleId: number): Promise<ErrorRule> {
        const options = { params: new HttpParams().set('errorRuleId', `${errorRuleId}`) };
        options.params = options.params.append('daysBack', 30);
        return this.httpService.get('/api/errorhandling/errorrules/get-errorrule', options).toPromise();
    }

    saveErrorRule(errorRule: ErrorRule, newPosition: RulePosition): Promise<ErrorRule> {
        const options = { params: new HttpParams().set('newPosition', `${newPosition}`) };
        return this.httpService.post('/api/errorhandling/errorrules/save-errorrule', errorRule, options).toPromise();
    }

    deleteErrorRule(errorRuleId: number): Promise<ErrorRule> {
        const options = { params: new HttpParams().set('errorRuleId', `${errorRuleId}`) };
        return this.httpService.post('/api/errorhandling/errorrules/delete-errorrule', null, options).toPromise();
    }

    saveSortOrder(orderedIds: number[]) {
        return this.httpService.post('/api/errorhandling/errorrules/save-errorrule-order', orderedIds).toPromise();
    }
}
